module.exports = __webpack_public_path__ + "img/trademark.487298e5.jpg";